import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { Tabs, TabList, Tab, TabPanels, TabPanel, List, UnorderedList, ListItem, FormControl, FormLabel, Input, InputLeftAddon, InputGroup, TableContainer, Table, Tbody, Td, Th, Thead, Tr } from '@chakra-ui/react'
import { useNavigate, useParams } from 'react-router-dom';
import { observer } from 'mobx-react';
import admin from '../../../api/admin';
import { IAsset } from '../../../models/asset';
import { GetAssetResponse } from '../../../models/admin-api/dto';
import ProgressLoader from '../../progressLoader';
import AssetAttachmentList from '../assetAttachmentList';
import { IMeta } from '../../../models/metaData';
import ExternalAssetAttachmentList from '../externalAssetAttachmentList';


const ExternalAssetViewer = props => {

    const [isLoading, setIsLoading] = useState(false);
    const [selectedAsset, setSelectedAsset] = useState<IAsset>();
    const [selectedMeta, setSelectedMeta] = useState<IMeta[]>([]);

    let { id } = useParams();


    useEffect(() => {

        let assetid = props.assetId || id;
        let password = props.password;

        if (process.env.REACT_APP_ASSET_INTEGRATION_MODULE == 'true') {
            password = 'password123';
        }

        if (assetid) {

            if (assetid !== undefined) {
                setIsLoading(true);

                admin.Assets.GetAssetViewer(assetid, props.sharedProjectId, password).then(
                    (res: GetAssetResponse) => {
                        if (res?.result!) {
                            setSelectedAsset(res.result);
                            if (res.result.meta) {
                                setSelectedMeta(JSON.parse(res.result.meta).items);
                            }
                            setIsLoading(false);
                        }
                        else {
                            setIsLoading(false)
                        }
                    },
                    (error) => {
                        alert('Error Retrieving asset!' + error);
                        setIsLoading(false);
                    }
                );
            }
            else {
                alert("Missing Asset ID!")
            }
        }
    }
        , [props.assetId, id]);




    return (
        <>
            {isLoading ? (<ProgressLoader />) :

                (<>

                    {selectedAsset ? (

                        <Tabs isFitted variant='enclosed'>
                            <TabList mb='1em'>
                                <Tab>Asset</Tab>
                                {process.env.REACT_APP_ASSET_INTEGRATION_MODULE ? (
                                    <Tab>Work Orders</Tab>
                                ) : (<Tab>Additional Details</Tab>)}

                                <Tab>Attachments</Tab>
                            </TabList>
                            <TabPanels>
                                {process.env.REACT_APP_ASSET_INTEGRATION_MODULE ? (<TabPanel>

                                    <>
                                        <InputGroup padding={1}>
                                            <InputLeftAddon>Name</InputLeftAddon><Input value={selectedAsset.description} />
                                        </InputGroup>
                                        <InputGroup padding={1}>
                                            <InputLeftAddon>Type</InputLeftAddon>
                                            <Input value={selectedAsset.type} /></InputGroup>
                                        <InputGroup padding={1}>
                                            <InputLeftAddon>Installation Date</InputLeftAddon>
                                            <Input value={selectedAsset.floorPlanLeft} /></InputGroup>
                                        <InputGroup padding={1}>
                                            <InputLeftAddon>Condition</InputLeftAddon>
                                            <Input value={""} /></InputGroup>
                                        <InputGroup padding={1}>
                                            <InputLeftAddon>DH Status</InputLeftAddon>
                                            <Input value={selectedAsset.manufacturer} /></InputGroup>

                                        <InputGroup padding={1}>
                                            <InputLeftAddon>Next Replacement</InputLeftAddon>
                                            <Input value={selectedAsset.floorPlanTop} /></InputGroup>

                                        <InputGroup padding={1}>
                                            <InputLeftAddon>Sub Location</InputLeftAddon>
                                            <Input value={selectedAsset.location} /></InputGroup>

                                        <InputGroup padding={1}>
                                            <InputLeftAddon>Asset ID</InputLeftAddon>
                                            <Input value={selectedAsset.name} /></InputGroup>

                                    </>

                                </TabPanel>) : (<TabPanel>

                                    <>
                                        <InputGroup padding={1}>
                                            <InputLeftAddon>Name</InputLeftAddon><Input value={selectedAsset.name} />
                                        </InputGroup>
                                        <InputGroup padding={1}>
                                            <InputLeftAddon>Type</InputLeftAddon>
                                            <Input value={selectedAsset.type} /></InputGroup>
                                        <InputGroup padding={1}>
                                            <InputLeftAddon>Manufacturer</InputLeftAddon>
                                            <Input value={selectedAsset.manufacturer} /></InputGroup>
                                        <InputGroup padding={1}>
                                            <InputLeftAddon>Model</InputLeftAddon>
                                            <Input value={selectedAsset.model} /></InputGroup>
                                        <InputGroup padding={1}>
                                            <InputLeftAddon>Serial No</InputLeftAddon>
                                            <Input value={selectedAsset.serialNo} /></InputGroup>

                                        <InputGroup padding={1}>
                                            <InputLeftAddon>Location</InputLeftAddon>
                                            <Input value={selectedAsset.location} /></InputGroup>

                                        <InputGroup padding={1}>
                                            <InputLeftAddon>Floor</InputLeftAddon>
                                            <Input value={selectedAsset.floor} /></InputGroup>

                                    </>

                                </TabPanel>)}

                                {process.env.REACT_APP_ASSET_INTEGRATION_MODULE ? (
                                    <TabPanel>
                                        <TableContainer>
                                            <Table size='sm'>
                                                <Thead>
                                                    <Tr>
                                                        <Th>Job No</Th>
                                                        <Th>Summary</Th>
                                                        <Th >Logged On</Th>
                                                        <Th >Target Date</Th>
                                                        <Th >Completed On</Th>
                                                        <Th >Job Status</Th>
                                                    </Tr>
                                                </Thead>
                                                <Tbody>
                                                    {selectedMeta.map((item: any) => (
                                                        <Tr>
                                                            <Td>{item.jobNumber}</Td>
                                                            <Td>{item.summary}</Td>
                                                            <Td>{item.logged}</Td>
                                                            <Td>{item.target}</Td>
                                                            <Td>{item.completed}</Td>
                                                            <Td>{item.status}</Td>
                                                        </Tr>
                                                    ))}
                                                </Tbody>

                                            </Table>
                                        </TableContainer>
                                    </TabPanel>
                                ) : (
                                    <TabPanel>
                                        <FormControl>
                                            {selectedMeta.map((item: IMeta) => (


                                                <>
                                                    <InputGroup padding={1}>
                                                        <InputLeftAddon>{item.Key}</InputLeftAddon>
                                                        <Input value={item.Value} /></InputGroup>
                                                </>


                                            ))}
                                        </FormControl>
                                    </TabPanel>
                                )}
                                <TabPanel>

                                    <ExternalAssetAttachmentList sharedProjectId={props.sharedProjectId} password={props.password} assetId={props.assetId} />

                                </TabPanel>
                            </TabPanels>
                        </Tabs>
                    ) : (<b>No Asset Information Found!</b>)}

                </>)
            }

        </>
    )
}


ExternalAssetViewer.propTypes = {
    assetId: PropTypes.number,
    password: PropTypes.string,
    sharedProjectId: PropTypes.string

}



export default observer(ExternalAssetViewer)